import { Avatar } from "radix-ui";
import styles from './css/Avatar.module.css';
import BoySvg from '@/assets/images/avatar-boy-svg.svg';
import GirlSvg from '@/assets/images/avatar-girl-svg.svg';
import { UserInfoResponse } from "@/services/generatedAPIs.schemas";

export function AvatarUser({
    user,
}: {
    user: UserInfoResponse
}) {
    return (
        <>
        <Avatar.Root className={styles.AvatarRoot}>
            <div
                className={styles.AvatarImage}
            >
                {
                    user.sex === 'female' ? <img src={GirlSvg} width="70px" height="70px"></img> :
                    user.sex === 'X' ? <div className={styles.AvatarNeutralCircle} /> :
                    <img src={BoySvg} width="70px" height="70px"></img>
                }
            </div>
        </Avatar.Root>
        {/* ≥1920 头像 top 由 60 抬到 95 (logo h=54 + 33px 间距),
            头像 bottom=165，姓名 mt 同步 136 → 171，保持原 6px 间距 */}
        <div className={["text-base text-sidebar-foreground font-semibold", "mt-34 min-[1920px]:mt-[171px]", "text-center"].join(' ')}>{user.name}</div>
        <div className={["text-sm text-sidebar-foreground/60", "text-center"].join(' ')}>{user.email}</div>
        </>
    )
}